export default function decimalFormat(value: number, absoluteNumber: boolean = false){
	return (absoluteNumber ? Math.abs(value) : value).toFixed(2);
}